module.exports = __webpack_public_path__ + "0588333e5338f908eaacca70b1cc7a9c.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_large_x1/public/team/CarolinaMastretta.png
// module id = 371
// module chunks = 0